import styled, { Icon, IconName, StyledComponent, Tooltip, withTheme } from '@se-admin/falcon';
import * as React from 'react';
import { IDiscountBadgeTooltip } from './discountBadgeTooltip.interfaces';

const CustomSpan: StyledComponent<'span', {}, {}> = styled('span')`
  display: block;
`;

CustomSpan.displayName = 'DiscountBadgeTooltipIconSpan';

/**
 * Represents the DiscountBadgeTooltip
 */
const DiscountBadgeTooltip: React.FunctionComponent<IDiscountBadgeTooltip> = ({
  position,
  discountTooltip,
  theme,
}) => {
  return (
    <Tooltip content={discountTooltip} position={position}>
      <CustomSpan>
        <Icon name={IconName.info} fillColor={theme.color.blackText} />
      </CustomSpan>
    </Tooltip>
  );
};

export default withTheme(DiscountBadgeTooltip);
